import React, { useState, useContext, useEffect, useMemo, useCallback } from 'react';
import { mapLocaleToMeaningfulFormat } from '@/helpers/utils/i18n';
import {
  getContentByTitle,
  getFilteredAttribute,
} from '../../../../../customercenter-ui/components/product/details/helpers/utils/productDataUtils';
import { Dialog, DialogContent, DialogTrigger } from '../../../../../customercenter-ui/components/ui/dialog';
import { ProductContext } from '../contexts';
interface SizeChart {
  className?: string;
}

const SizeChart: React.FC<SizeChart> = () => {
  const { widgetData, initialColor, initialSize } = useContext(ProductContext);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [openModal, setOpenModal] = useState<boolean>(false);
  const sizeChartVisible = useMemo(() => {
    return initialColor?.categories?.filter((item: any) => {
      return item?.ancestors?.filter((subItem: any) => {
        return subItem?.name?.includes('Jewelry');
      })?.length
        ? true
        : false;
    })?.length === 0 && initialColor?.variants?.length === 0
      ? false
      : true;
  }, [initialColor]);

  const [sizeChartHTML, setSizeChartHTML] = useState('');

  useEffect(() => {
    const sizeChartJSON = JSON.parse(widgetData.sizeChartJSON);
    let sizeChartTitle = '';
    Object.keys(sizeChartJSON).forEach((key) => {
      let fullMatchCount = 0;
      key?.split('@@').forEach((subKey) => {
        if (
          subKey?.split('###')?.[1] ===
          getFilteredAttribute(subKey?.split('###')[0], initialSize, subKey?.split('###')?.[1])
        ) {
          fullMatchCount++;
        }
      });
      if (fullMatchCount === key?.split('@@')?.length) {
        sizeChartTitle = sizeChartJSON[key];
      }
    });
    if (sizeChartTitle !== '') {
      getContentByTitle(sizeChartTitle, false).then((data: any) => {
        setSizeChartHTML(data?.htmlContentEntries?.[0]?.rich_text_and_html_editor || '');
      });
    }
  }, [initialSize]);

  const onCloseOpenedModalEvent = useCallback((event: any) => {
    const customEvent = event as CustomEvent<{ value: string }>;
    if (customEvent && customEvent.detail) {
      const value = customEvent.detail.value;
      if ('SizeChartModal' === value) {
        setOpenModal(false);
      }
    }
  }, []);

  useEffect(() => {
    window.addEventListener('closeOpenedModalEvent', onCloseOpenedModalEvent);
    const observer = new MutationObserver(() => {
      const buttons = document?.querySelectorAll('.scroll-to-top');
      buttons?.forEach((button) => {
        button.addEventListener('click', () => {
          const targetSectionId = button.getAttribute('data-target-id');
          if (targetSectionId) {
            const sectionToShow = document.getElementById(targetSectionId);
            sectionToShow?.scrollIntoView({
              behavior: 'smooth',
            });
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
      window.removeEventListener('closeOpenedModalEvent', onCloseOpenedModalEvent);
    };
  }, []);

  return (
    <Dialog>
      <section>
        <DialogTrigger asChild>
          {sizeChartVisible && <button className="underline">{mapLocaleToMeaningfulFormat().sizeChart}</button>}
        </DialogTrigger>
        <DialogContent className="h-[calc(100%_-_48px)] w-[calc(100%_-_16px)] max-w-[840px] bg-white pb-6 pl-6 pr-5 pt-7">
          <h1 className="mb-2 text-2xl font-bold">{mapLocaleToMeaningfulFormat().sizeChart}</h1>
          <section className="customtablescrollbar justify-center overflow-scroll">
            <section className="pb-4" dangerouslySetInnerHTML={{ __html: sizeChartHTML }}></section>
          </section>
        </DialogContent>
      </section>
    </Dialog>
  );
};

export default SizeChart;
